import { Button } from '@cian/ui-kit';
import { IconActionCompareAdd24, IconActionCompareAdded24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { ADD_TO_COMPARE_LABEL, COMPARE_BUTTON_DATA_MARK, REMOVE_FROM_COMPARE_LABEL } from './constants';

interface ICompareButtonControlProps {
  isAdded: boolean;
  onClick(): void;
}

export function CompareButtonControl({ isAdded, onClick }: ICompareButtonControlProps) {
  return (
    <Button
      beforeIcon={
        isAdded ? (
          <IconActionCompareAdded24 color="icon-main-default" />
        ) : (
          <IconActionCompareAdd24 color="icon-main-default" />
        )
      }
      theme="stroke_primary"
      size="M"
      onClick={onClick}
      data-mark={COMPARE_BUTTON_DATA_MARK}
      data-testid="NewbuildingHeaderCompareButton"
      aria-label={isAdded ? REMOVE_FROM_COMPARE_LABEL : ADD_TO_COMPARE_LABEL}
    />
  );
}
